import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ReBox from "../../../../common/ReBox";
import { GlobalContext } from "../../../../common/Context";
import { useTranslation } from "react-i18next";
import { grey, text } from "../../../../../theme/colours";

const SkillCard = ({ skill, icon }) => {
  const { t } = useTranslation(["Tryps", "ScoreCategories"]);
  const { mobileView, desktopView } = useContext(GlobalContext);
  const [open, setOpen] = useState(false);
  const [lastSkillClicked, setLastSkillClicked] = useState(null);

  const cardStyle = {
    display: "flex",
    alignItems: "center",
    width: desktopView ? "23%" : "48%",
    height: "2.5rem",
    mt: "1rem",
    p: mobileView ? "3%" : "2%",
    borderRadius: "0.3rem",
  };
  const imgStyle = {
    width: "1.3rem",
    height: "1.3rem",
    mr: "0.5rem",
    "& svg *": {
      fill: text.primary,
    },
  };
  const skillStyle = { textTransform: "capitalize" };
  const infoStyle = {
    position: "absolute",
    top: "15%",
    right: "5%",
    color: grey[1],
    fontSize: "0.5rem",
  };
  const modalStyle = {
    position: "absolute",
    top: "-50%",
    left: "-12.5%",
    width: "125%",
    padding: desktopView ? "9%" : "7%",
    zIndex: 1,
    visibility: open ? "visible" : "hidden",
  };

  const handleInfoClick = () => {
    setOpen(true);
    if (skill !== lastSkillClicked) {
      setLastSkillClicked(skill);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", () => {
      setOpen(false);
    });
    return () => {
      document.removeEventListener("mousedown", () => {
        setOpen(false);
      });
    };
  }, []);

  return (
    <ReBox style={cardStyle}>
      <Box sx={imgStyle}>{icon}</Box>
      <Typography sx={skillStyle} variant="body1">
        {t(`ScoreCategories:${skill}`)}
      </Typography>
      <InfoIcon
        sx={infoStyle}
        onClick={() => {
          handleInfoClick();
        }}
      />
      <ReBox style={modalStyle}>
        <Typography variant="body1">
          {t("trypsSkillDesc", { context: skill })}
        </Typography>
      </ReBox>
    </ReBox>
  );
};

export default SkillCard;
